<div [formGroup]="form">
  <input formControlName="id" type="hidden" />
  <pr-input-radio
    formControlName="hasLoan"
    label="Financement"
    toggleBgEmpty="true"
    [options]="[
      { label: 'À crédit', value: true },
      { label: 'En cash', value: false },
    ]"
  ></pr-input-radio>

  <div [hidden]="!form.get('hasLoan').value">
    <!-- Détenteurs + part de détention (owners). `ownerIds` déprécié. -->
    <pr-input-owner-share
      formControlName="owners"
      [derrors]="derrors"
    ></pr-input-owner-share>

    <pr-input label="Catégorie" [derrors]="derrors">
      <mat-select formControlName="category">
        @for (category of loanCategories; track category) {
          <mat-option [value]="category.id">
            {{ category.value }}
          </mat-option>
        }
      </mat-select>
    </pr-input>

    <pr-input-radio
      formControlName="knowTotal"
      label="Je connais le montant"
      toggleBgEmpty="true"
      [options]="[
        { value: true, label: 'Emprunté' },
        { value: false, label: 'Restant dû' },
      ]"
    >
    </pr-input-radio>

    <div [hidden]="!form.get('knowTotal').value">
      <pr-input [label]="'Montant emprunté'" [suffix]="'€'" [derrors]="derrors"
        ><input formControlName="amountBorrowed" type="text"
      /></pr-input>

      <pr-input-date
        formControlName="signatureDate"
        label="Date de signature"
        [derrors]="derrors"
      ></pr-input-date>
      <pr-input-date
        formControlName="startDate"
        label="Date de début"
        [derrors]="derrors"
      ></pr-input-date>

      <pr-input-slider
        [label]="'Durée totale'"
        formControlName="durationTotalInMonth"
        suffix="mois"
        min="1"
        max="360"
        step="1"
        [derrors]="derrors"
      >
      </pr-input-slider>
    </div>

    <div [hidden]="form.get('knowTotal').value">
      <pr-input [label]="'Montant dû'" [suffix]="'€'" [derrors]="derrors"
        ><input formControlName="amountBorrowed" type="text"
      /></pr-input>

      <pr-input-slider
        [label]="'Durée restante'"
        formControlName="durationTotalInMonth"
        suffix="mois"
        min="1"
        max="360"
        step="1"
        [derrors]="derrors"
      >
      </pr-input-slider>
    </div>

    <!-- Global -->
    <pr-input-slider
      [label]="'Taux du crédit'"
      formControlName="interestRate"
      suffix="%"
      min="0.1"
      max="5"
      step="0.1"
      [derrors]="derrors"
    >
    </pr-input-slider>

    <pr-input-slider
      [label]="'Taux de l\'assurance'"
      formControlName="insuranceRate"
      suffix="%"
      min="0.1"
      max="2"
      step="0.1"
      [derrors]="derrors"
    >
    </pr-input-slider>

    <div [hidden]="!isPaliersAvailable">
      <h3 class="drawer-title">Paliers</h3>

      <ea-loan-paliers
        [form]="form"
        [derrors]="derrors"
        [startDate]="form.get('startDate').value"
      ></ea-loan-paliers>
    </div>
  </div>

  <div></div>
</div>
